import numeral from 'numeral';

numeral.register('locale', 'gr', {
    delimiters: {
        thousands: '.',
        decimal: ','
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
    },
    ordinal: function (number) {
        return '';
    },
    currency: {
        symbol: '€'
    }
});
